<template>
    <v-dialog v-model="dialog" max-width="800px" persistent scrollable>
        <v-card class="rounded-xl">
            <v-card-title class="text-h6 font-weight-bold pt-6 px-8 grey--text text--darken-3">
                <v-icon left color="teal darken-4" class="mr-3">mdi-file-document-edit</v-icon>
                {{isEdit ? "Cập Nhật Hợp Đồng" :"Tạo Mới Hợp Đồng"}}
                <v-spacer></v-spacer> 
                <v-btn icon color="grey" @click="dialog=false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider></v-divider>
            
            <v-card-text class="pa-8">
                <v-form v-model="valid" ref="form" @submit.prevent="saveData" id="contractForm" >
                    
                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 d-flex align-center">
                        <v-icon small color="teal darken-4" class="mr-2">mdi-information-outline</v-icon>
                        THÔNG TIN CƠ BẢN
                    </div>

                    <v-card outlined rounded="lg" class="grey lighten-5 mb-6">
                      <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Chọn nhân viên <span class="red--text">*</span></label>
                                <v-autocomplete outlined dense hide-details="auto" persistent-placeholder class="rounded-lg bg-white" background-color="white" prepend-inner-icon="mdi-account"
                                :items="employees" item-value="code" item-text="name" v-model="form.employeeAcode" :search-input.sync="employeeSearch"
                                placeholder="Tìm theo Mã/Tên nhân viên" clearable hide-no-data @change="fetchEmployee" :rules='[v=>!!v||"Chọn dữ liệu"]' :readonly="!!employee || isEdit"> 
                                    <template v-slot:selection="data">
                                        <strong>{{ data.item.code }}</strong>&nbsp;- {{data.item.name}} ({{data.item.department}})
                                    </template>
                                    <template v-slot:item="data">
                                        <strong>{{ data.item.code }}</strong>&nbsp;- {{data.item.name}} ({{data.item.department}})
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Loại hợp đồng <span class="red--text">*</span></label>
                                <v-autocomplete outlined dense hide-details="auto" persistent-placeholder class="rounded-lg bg-white" background-color="white"
                                    :items="contractTypes" item-text="name" item-value="code" placeholder="Chọn loại hợp đồng" v-model="form.contractTypeCode" prepend-inner-icon="mdi-file-document-outline"
                                    :rules="[v=>!!v||'Nhập dữ liệu']">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Thời hạn hợp đồng</label>
                                <v-select outlined dense hide-details="auto" persistent-placeholder class="rounded-lg bg-white" background-color="white"
                                    :items="contractCategories" item-text="name" item-value="code" placeholder="Chọn thời hạn" v-model="form.contractCategoryCode" prepend-inner-icon="mdi-timer-sand">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Mức Lương <span class="red--text">*</span></label>
                                <v-text-field dense outlined persistent-placeholder hide-details="auto" v-model="form.salary" class="rounded-lg bg-white" background-color="white" placeholder="0" prepend-inner-icon="mdi-cash"
                                :rules="[
                                    v=>(v!=null || v != undefined) || 'Nhập dữ liệu',
                                    v => !/\D/.test(v) || 'Dữ liệu không đúng' 
                                ]" :hint="currencyFormat(form.salary)" suffix="VNĐ"></v-text-field>
                            </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 d-flex align-center">
                        <v-icon small color="teal darken-4" class="mr-2">mdi-shield-check-outline</v-icon>
                        THÔNG TIN ĐÓNG BẢO HIỂM
                    </div>

                    <v-card outlined rounded="lg" class="grey lighten-5 mb-6">
                      <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Mức đóng</label>
                                <v-text-field dense outlined persistent-placeholder hide-details="auto" v-model="form.payRange" class="rounded-lg bg-white" background-color="white" placeholder="Nhập dải lương" prepend-inner-icon="mdi-cash-plus"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Đóng từ</label>
                                <v-text-field dense outlined persistent-placeholder hide-details="auto" v-model="form.payFrom" class="rounded-lg bg-white" background-color="white" type="date" prepend-inner-icon="mdi-calendar-start"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Số Tiền</label>
                                <v-text-field dense outlined persistent-placeholder hide-details="auto" v-model="form.payAmount" class="rounded-lg bg-white" background-color="white" placeholder="0" prepend-inner-icon="mdi-cash-multiple"
                                :hint="currencyFormat(form.payAmount)" suffix="VNĐ"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Thời gian chốt sổ</label>
                                <v-text-field dense outlined persistent-placeholder hide-details="auto" class="rounded-lg bg-white" background-color="white" v-model="form.closeDate" type="date" prepend-inner-icon="mdi-calendar-remove"></v-text-field>
                            </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 d-flex align-center">
                        <v-icon small color="teal darken-4" class="mr-2">mdi-calendar-range</v-icon>
                        THỜI GIAN HIỆU LỰC
                    </div>

                    <v-card outlined rounded="lg" class="grey lighten-5 mb-6">
                      <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Ngày ký / Bắt đầu <span class="red--text">*</span></label>
                                <v-text-field dense outlined persistent-placeholder hide-details="auto" class="rounded-lg bg-white" background-color="white" v-model="form.signDate" type="date" prepend-inner-icon="mdi-calendar-start"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <label class="caption font-weight-bold grey--text text--darken-1 mb-1 d-block text-uppercase">Ngày hết hạn <span class="red--text">*</span></label>
                                <v-text-field dense outlined persistent-placeholder hide-details="auto" class="rounded-lg bg-white" background-color="white" v-model="form.expireDate" type="date" prepend-inner-icon="mdi-calendar-end"></v-text-field>
                            </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 d-flex align-center">
                        <v-icon small color="teal darken-4" class="mr-2">mdi-note-multiple-outline</v-icon>
                        GHI CHÚ & BỔ SUNG
                    </div>

                    <v-card outlined rounded="lg" class="grey lighten-5 mb-6">
                      <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea v-model="form.note" class="rounded-lg bg-white" background-color="white" placeholder="Nội dung ghi chú" outlined persistent-placeholder hide-details="auto" rows="3"></v-textarea>
                            </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <div class="subtitle-1 font-weight-bold teal--text text--darken-4 mb-4 d-flex align-center" v-if="item && form.attachmentUrl">
                        <v-icon small color="teal darken-4" class="mr-2">mdi-paperclip</v-icon>
                        TÀI LIỆU ĐÍNH KÈM
                    </div>

                    <v-card outlined rounded="lg" class="grey lighten-5" v-if="item && form.attachmentUrl">
                      <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <iframe :src="`https://docs.google.com/viewerng/viewer?url=${form.attachmentUrl}&embedded=true`" frameborder="0" height="500" width="100%" class="rounded-lg">
                                </iframe>
                            </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-6">
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" text class="font-weight-bold px-8" @click="dialog=false">HỦY BỎ</v-btn>
                <v-btn dark form="contractForm" type="submit" color="teal darken-4" class="rounded-pill elevation-2 px-10 font-weight-bold ml-4">LƯU LẠI</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import http from '@/components/services/http-common';
import moment from 'moment/moment';
export default {
    props:["value", "item", "employee"],
    watch:{
        employeeSearch:{
            handler(val){
                this.fetchEmployee(val);
            }
        },
        value: {
            handler(val){
                if(val)
                {
                    this.fetchContractType()
                    this.fetchContractCategory()
                    if(this.employee){
                        this.fetchEmployee(this.employee)
                        this.form.employeeAcode = this.employee
                    }
                    if(this.isEdit)
                        this.fetch();
                }
                else{
                    this.close();
                }
            }
        },
        "form.lengthType": function(val){
            if(val!='nolimit')
            {
                var length = val.match(/\d+/g);
                var unit = val.match(/[a-zA-Z]+/g);
                console.log(length.toString());
                var newDate = moment(this.form.signDate, "YYYY-MM-DD").add(length, unit);
                this.form.expireDate = newDate.format("YYYY-MM-DD");
            }else {
                this.form.expireDate = moment("2050-01-01").format("YYYY-MM-DD");
            }
        }

        // FETCHING DATA
        // "form.departmentTypeCode": function (val) {
        //     this.fetchDepartment(this.form.departmentTypeCode);
        // },
        // "form.departmentCode": function(val){
        //     this.fetchPosition(this.form.departmentCode);
        // },
        // "form.positionCode": function(val){
        //     this.fetchPositionState(this.form.positionCode);
        // },
        // "form.positionStateCode": function(val) {
        //     this.fetchShift(this.form.positionStateCode);
        // },
    },
    computed: {
        dialog: {
            get: function () {
                return this.value;
            },
            set: function (val){
                this.$emit("input", val)
            }
        },
        isEdit() {
            return !!this.item;
        }
    },
    data() {
        return {
            ROOT_URL: "contracts/",
            EMPLOYEE_FETCH: "employees/search",
            DEPARTMENT_FETCH: "departmentTypes/fetch-department/",
            DEPARTMENT_TYPE_FETCH: "departmentTypes/fetch",
            POSITION_STATE_FETCH: "positions/fetch-position-state",
            SHIFT_FETCH: "positionStates/fetch-shift/",
            POSITION_FETCH: "departments/fetch-position/",
            SCALE_FETCH: "scales/fetch",

            endpoint: process.env.VUE_APP_BASE_URL,
            valid: true,
            departmentSearch: null,
            departmentTypes: [],
            positionStates: [],
            departments: [],
            shifts: [],
            positions: [],
            scales: [],
            employeeSearch: null,
            employees: [],
            contractTypes: [],
            contractCategories: [],
            file: null,
            form: {
                code:null,
                employeeAcode:null,
                contractNumber:null,
                contractTypeCode:null,
                signDate:moment().format("YYYY-MM-DD"),
                expireDate:moment().format("YYYY-MM-DD"),
                createdBy:null,
                salary:null,
                payRange:null,
                payFrom:null,
                payAmount:null,
                closeDate:null,
                length: 1,
                lengthUnit: "MONTH",
                lengthType:"1years",
                status:0,
                attachmentUrl:"",
                note: null,
            },
            defaultForm:{
                code:null,
                employeeAcode:null,
                contractNumber:null,
                contractTypeCode:null,
                signDate:moment().format("YYYY-MM-DD"),
                expireDate:moment("2100-12-31", "YYYY-MM-DD").format("YYYY-MM-DD"),
                createdBy:null,
                salary:null,
                payRange:null,
                payFrom:null,
                payAmount:null,
                closeDate:null,
                length: 1,
                lengthUnit: "MONTH",
                lengthType:"1years",
                status:0,
                attachmentUrl:"",
                note: null,
            }
        }
    },
    methods: {
        currencyFormat(x) {
            if(x!=null)
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        fetchEmployee() {
            return http.get(this.EMPLOYEE_FETCH).then(res => {
                this.employees = res.data;
            });
        },
        
        fetch(){
            return http.get(this.ROOT_URL+this.item.code).then(res => {
                res.data.signDate = moment(res.data.signDate, "YYYY-MM-DD").format("YYYY-MM-DD");
                res.data.expireDate = moment(res.data.expireDate, "YYYY-MM-DD").format("YYYY-MM-DD");
                if(res.data.closeDate) res.data.closeDate = moment(res.data.closeDate, "YYYY-MM-DD").format("YYYY-MM-DD");
                if(res.data.payFrom) res.data.payFrom = moment(res.data.payFrom, "YYYY-MM-DD").format("YYYY-MM-DD");
                this.form = Object.assign({}, res.data);
                this.fetchEmployee();
                console.log(this.form)
            })
        },
        saveData() {
            this.$refs.form.validate();
            if(this.valid)
            {
                if(!this.item)
                {
                    var formData = new FormData();
                    formData.append("attachmentFile", this.file);
                    formData.append("code", this.form.code);
                    formData.append("employeeAcode", this.form.employeeAcode);
                    formData.append("contractNumber", this.form.contractNumber);
                    formData.append("contractTypeCode", this.form.contractTypeCode);
                    formData.append("contractCategoryCode", this.form.contractCategoryCode);
                    formData.append("signDate", this.form.signDate);
                    formData.append("expireDate", this.form.expireDate);
                    formData.append("createdBy", this.form.createdBy);
                    formData.append("salary", this.form.salary);
                    formData.append("payRange", this.form.payRange || "");
                    formData.append("payFrom", this.form.payFrom || "");
                    formData.append("payAmount", this.form.payAmount || "");
                    formData.append("closeDate", this.form.closeDate || "");
                    formData.append("length", this.form.length);
                    formData.append("lengthUnit", this.form.lengthUnit);
                    formData.append("lengthType", this.form.lengthType);
                    formData.append("status", this.form.status);
                    formData.append("note", this.form.note || "");
                    
                    return http.post(this.ROOT_URL, formData)
                    .then(res => {
                        this.$emit("fetchData");
                    })
                    .catch(err => {
                    });
                }else {
                    return http.put(this.ROOT_URL + this.item.code, this.form)
                    .then(res => {
                        this.$emit("fetchData");
                    })
                    .catch(err => {

                    });
                }
            }
        },
        fetchContractType(){
            return http.get("contractTypes/fetch").then(res=>{
                this.contractTypes = res.data;
            })
        },
        fetchContractCategory() {
            return http.get("contractCategories/simple").then(res => {
                this.contractCategories = res.data
            })
        },
        close(){
            this.form = Object.assign({}, this.defaultForm);
            this.$refs.form.resetValidation();
        }
    },
    created() {
    }
    
}
</script>